<template lang="pug">
#food_package
  section.banner.position-relative
    div.picture
        img.img-fluid.big(src="img/banner/banner_food_medicine.jpg" alt="banner-certificate")
        img.img-fluid.small(src="img/banner/banner_food_medicine_mobile.jpg" alt="banner-certificate")
    div.mask_banner
    div.breadcrumb_block
      b-container
        b-breadcrumb(:items="breadcrumb_items")
    div.banner_h1
      h1 食藥醫療
  b-container.py-0.py-lg-5.slogan
    p.text-center.font-weight-bolder.py-5 採用吸塑設備，利用高溫及模具，將平面的塑膠片，成型出立體包裝曲面殼，以讓消費者可直接透視產品並保護之。
  section#product_profile
    b-row.menu
      b-col.text-center.position-relative(:class="{ active: p_show[1].show }" @click='change("APET")') PVC
      b-col.text-center(:class="{ active: p_show[0].show }" @click='change("PVC")') APET
    b-container.pt-md-4
      b-row#pvc_detail.detail.pb-5.py-md-5(:class="{ active: p_show[1].show }") 
        b-col(cols="12" md="8" order="2" order-md="1")
          div
            h3 
              span 產品特點
            p 本製品具有優良的成型性及耐衝擊性，且可防止氧氣、溼氣透過，極適合做為各項食品或藥品之包裝。
          div
            h3 
              span 產品特性
            ol
              li(v-for="item in p_feature" :key="item.message") {{ item.message }}
          div
            h3 
              span 產品用途
            ol
              li(v-for="item in p_use" :key="item.message") {{ item.message }}
        b-col.align-self-center.text-center.pb-5.pb-md-0(cols="12" md="4" order="1" order-md="2")
          swiper.swiper.swiper_product_img(:options="swiperOption_product_img")
            swiper-slide(v-for="item in product_img_data_pvc" :key="item.id")
              b-img.w-100(:src="item.img_src",:alt="item.img_alt",:title="item.img_alt" )
            div.swiper-pagination(slot="pagination")
      b-row#apet_detail.detail.pb-5.py-md-5(:class="{ active: p_show[0].show }") 
        b-col(cols="12" md="8" order="2" order-md="1")
          div
            h3 
              span 產品特點
            p 本製品具有優良之透明外觀，採用無毒配方，符合衛生安全規定，可適用於一般食品或藥品包裝之材料(如：冷水杯、冷水杯蓋、巧克力盒、水果盒、蛋包裝盒、冷藏食品盒、餅盒、糖果盒、一般食品盒、藥品包裝及針藥瓶包裝等)。				
          div
            h3 
              span 產品特性
            ol
              li(v-for="item in a_feature" :key="item.message") {{ item.message }}
          div
            h3 
              span 產品用途
            ol
              li(v-for="item in a_use" :key="item.message") {{ item.message }}
        b-col.align-self-center.text-center.pb-5.pb-md-0(cols="12" md="4" order="1" order-md="2")
          swiper.swiper.swiper_product_img(:options="swiperOption_product_img")
            swiper-slide(v-for="item in product_img_data_apet" :key="item.id")
              b-img.w-100(:src="item.img_src",:alt="item.img_alt",:title="item.img_alt")
            div.swiper-pagination(slot="pagination")
  section#specification.py-5(:class="{ active: p_show[1].show }") 
    div.mask
    h2.text-center 
      span PVC 產品規格
    b-container(fluid)
      //- swiper.swiper.py-5(:options="swiperOption_pvc").swiper_pvc.swiper_product_col_3
      swiper.swiper.py-5(:options="swiperOption_pvc").swiper_pvc.swiper_product_col_3
        swiper-slide(v-for="item in p_specification" :key="item.id")
          ul
            li 
              span {{ item.name }}
            li 
              span {{ item.feature }}
            li 
              span {{ item.outward }}
            li 
              span(v-html="item.thickness")
            li 
              span(v-html="item.proportion")
            li 
              span(v-html="item.pull")
            li 
              span(v-html="item.elongation")
            li 
              span(v-html="item.heating")
            li 
              span(v-html="item.vcm")
        div.swiper-pagination(slot="pagination")
  section#specification.py-5(:class="{ active: p_show[0].show }") 
    div.mask
    h2.text-center 
      span  APET 產品規格
    b-container(fluid)
      swiper.swiper.py-5(:options="swiperOption_apet").swiper_apet.swiper_product_col_5
        swiper-slide(v-for="item in a_specification" :key="item.id")
          ul
              li 
                span {{ item.name }}
              li 
                span {{ item.feature }}
              li 
                span {{ item.outward }}
              li 
                span(v-html="item.thickness")
              li 
                span(v-html="item.proportion")
              li 
                span(v-html="item.transmittance")
              li 
                span(v-html="item.gloss")
              li 
                span(v-html="item.mist")
        div.swiper-pagination(slot="pagination")
  section#others.py-5 
    b-container
      h3 其他應用
      swiper.swiper.py-5(:options="swiperOption")
        swiper-slide(v-for="item in swiperdata" :key="item.id")
          div
            router-link(:to="item.href_link")
              div
                b-img.w-100(:src="item.url" fluid)
                h5 {{item.name}}
              p.py-4 {{item.text}}
              svg.o_arrow_r(viewbox="0 0 50 30")
                line(x1=0 y1=20 x2=45 y2=20)
                line(x1=45 y1=20 x2=31 y2=8)
        div.swiper-pagination(slot="pagination")
        div.swiper-button-prev(slot="button-prev")
          svg(width="65px" height="65px" viewBox="0 0 65 65" style="transform: scale( 1.75) rotate(180deg)")
            g(id="desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd")
              g(id="product" transform="translate(-1250.000000, -2680.000000)" stroke="#979797")
                  g(id="arrow" transform="translate(1282.500000, 2710.500000) rotate(-180.000000) translate(-1282.500000, -2710.500000) translate(1255.000000, 2683.000000)")
                    circle(stroke-width="1.1" fill="#FFFFFF" cx="27.3493151" cy="27.3493151" r="27.3493151")
                    polyline(stroke-width="3.3" stroke-linecap="round" stroke-linejoin="round" fill="none" points="29.0068493 19.0616438 20.7191781 27.3493151 29.0068493 35.6369863")
        div.swiper-button-next(slot="button-next")
          svg(width="65px" height="65px" viewBox="0 0 65 65" style="transform: scale( 1.75)")
            g(id="desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd")
              g(id="product" transform="translate(-1250.000000, -2680.000000)" stroke="#979797")
                  g(id="arrow" transform="translate(1282.500000, 2710.500000) rotate(-180.000000) translate(-1282.500000, -2710.500000) translate(1255.000000, 2683.000000)")
                    circle(stroke-width="1.1" fill="#FFFFFF" cx="27.3493151" cy="27.3493151" r="27.3493151")
                    polyline(stroke-width="3.3" stroke-linecap="round" stroke-linejoin="round" fill="none" points="29.0068493 19.0616438 20.7191781 27.3493151 29.0068493 35.6369863")
</template>
<script>
export default {
    metaInfo: {
        title: 'PVC / APET食藥包裝-南亞硬質膠布',
        titleTemplate: '',
        meta: [
            { name: 'description', content: 'PVC硬質膠布具有優良的成型性及耐衝擊性，可防止氧氣、溼氣透過，極適合做為食品或藥品之包裝。PVC藥品包裝材通過FDA認證、食品級真空成型具防霧效果。APET具有優良之透明外觀，採用無毒配方，符合衛生安全規定，可適用於一般食品或藥品包裝之材料。食品級真空成型用APET具有防霧效果，防護面罩具抗菌、防霧效果。' },
            { name: 'Keywords', content: '南亞塑膠、硬質膠布、PVC、APET、食藥包裝、藥品包裝、食品級、真空成型、微波、烘焙。' },
            { name: 'og:title', content: 'PVC / APET食藥包裝-南亞硬質膠布' },
            { name: 'og:type', content: 'website' },
            { name: 'og:url', content: 'https://www.nan-ya-pvc.com.tw/' },
            { name: 'og:description', content: 'PVC硬質膠布具有優良的成型性及耐衝擊性，可防止氧氣、溼氣透過，極適合做為食品或藥品之包裝。PVC藥品包裝材通過FDA認證、食品級真空成型具防霧效果。APET具有優良之透明外觀，採用無毒配方，符合衛生安全規定，可適用於一般食品或藥品包裝之材料。食品級真空成型用APET具有防霧效果，防護面罩具抗菌、防霧效果。' },
            { name: 'og:image', content: 'https://www.nan-ya-pvc.com.tw/img/OGimage.jpg' },
        ],
    },
  data() {
      return {
        breadcrumb_items: [
          {
            text: 'Home',
            to: { name: 'App' }
          },
          {
            text: '食藥醫療',
            active: true
          }
        ],
        swiperOption_product_img: {
          slidesPerView: 1,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          }
        },
        product_img_data_pvc: [
          { 
            id: '1',
            img_src: 'img/application_Desktop/food_medicine_img_01.jpg',
            img_alt: '南亞PVC、APET食品級真空成型膠布採用無毒配方，符合衛生安全規定，具抗菌、防霧效果。' },
          { 
            id: '2',
            img_src: 'img/application_Desktop/food_medicine_img_02.jpg',
            img_alt: '南亞PVC、APET食品級真空成型膠布採用無毒配方，符合衛生安全規定，具抗菌、防霧效果。' },
          { 
            id: '3',
            img_src: 'img/application_Desktop/food_medicine_img_03.jpg',
            img_alt: '南亞PVC藥品包裝材通過FDA認證' }
        ],
        product_img_data_apet: [
          { 
            id: '4',
            img_src: 'img/application_Desktop/food_medicine_img_04.jpg',
            img_alt: '南亞APET抗菌、防霧，適合作為防護面罩。' },
          { 
            id: '1',
            img_src: 'img/application_Desktop/food_medicine_img_01.jpg',
            img_alt: '南亞PVC、APET食品級真空成型膠布採用無毒配方，符合衛生安全規定，具抗菌、防霧效果。' },
          { 
            id: '2',
            img_src: 'img/application_Desktop/food_medicine_img_02.jpg',
            img_alt: '南亞PVC、APET食品級真空成型膠布採用無毒配方，符合衛生安全規定，具抗菌、防霧效果。' },
          { 
            id: '3',
            img_src: 'img/application_Desktop/food_medicine_img_03.jpg',
            img_alt: '南亞PVC藥品包裝材通過FDA認證' }
        ],
        p_show: [
          {show: true},
          {show: false}
        ],
        p_feature: [
          { message: '採用特殊無毒配方生產。' },
          { message: '符合台灣CNS、日本PL及美國FDA食品衛生規格，能確保包裝使用上的衛生性。' },
          { message: '符合歐盟REACH、ROHS規範要求。' },
          { message: '真空成型性佳。' },
          { message: '抗化學藥品性佳。' },
          { message: '可依客戶需要，生產抗靜電、抗紫外線及高耐衝擊性等製品。' }
        ],
        p_use: [
          { message: '可客製化項目：爽身、電暈、耐寒、耐溫、耐候、耐燃、抗靜電及防霧等。' },
          { message: '檢驗規範：ASTM D-1593、ASTM D-792、JIS-K6734及ASTM D-3680等。' }
        ],
        a_feature: [
          { message: '無毒性環保材質。' },
          { message: '透明度佳。' },
          { message: '真空成型性良好。' }
        ],
        a_use: [
          { message: '可客製化項目：爽身、電暈、耐寒、抗靜電、防霧、抗菌及高週波等。' },
          { message: '檢驗規範：ASTM D-1593、ASTM D-792、ASTM D-1003及ASTM D-523等。' }
        ],
        p_specification: [
          { 
            id: '1',
            name: '藥品包裝VFFP',
            feature: '特色: 易成型、耐衝擊、耐腐蝕',
            outward: '外觀: 透明、有色',
            thickness: '參考厚度<sub>(mm)</sub>：0.25',
            proportion: '比重<sub>(g/cm3)</sub>：1.35±3%',
            pull: '拉力強度<sub>(kg/cm2)</sub>:<br/><span class="pl-5">MD>450/CD>400</span>',
            elongation: '伸長率<sub>(%)</sub>：<br/><span class="pl-5">MD>135/CD>90</span>',
            heating: '加熱收縮<sub>(%,150°CX10分)</sub>：<br/><span class="pl-5">MD-4~-7/CD<2</span>',
            vcm: 'VCM含量<sub>(ppm)</sub>：<1' },
          { 
            id: '2',
            name: '食品一般真空成型VFVG',
            feature: '特色: 易成型、耐衝擊、耐腐蝕',
            outward: '外觀: 透明、有色',
            thickness: '參考厚度<sub>(mm)</sub> ：0.25',
            proportion: '比重<sub>(g/cm3)</sub> ：1.35±3%',
            pull: '拉力強度<sub>(kg/cm2)</sub>：<br/><span class="pl-5">MD>450/CD>400</span>',
            elongation: '伸長率<sub>(%)</sub> ：<br/><span class="pl-5">MD>135/CD>90</span>',
            heating: '加熱收縮<sub>(%,150°CX10分)</sub>：<br/><span class="pl-5">MD-6~-11/CD<1.5</span>',
            vcm: 'VCM含量(ppm)</sub>：<1' },
          { 
            id: '3',
            name: '食品深模真空成型VFVD',
            feature: '特色: 易成型、耐衝擊、耐腐蝕',
            outward: '外觀: 透明、有色',
            thickness: '參考厚度<sub>(mm)</sub> ：0.25',
            proportion: '比重<sub>(g/cm3)</sub> ：1.35±3%',
            pull: '拉力強度<sub>(kg/cm2)</sub>：<br/> <span class="pl-5">MD>450/CD>400</span>',
            elongation: '伸長率<sub>(%)</sub>：<br/> <span class="pl-5">MD>135/CD>90</span>',
            heating: '加熱收縮<sub>(%,150°CX10分)</sub>：<br/> <span class="pl-5">MD-5.5~-11/CD<1</span>',
            vcm: 'VCM含量<sub>(ppm)</sub>：<1' }
        ],
        a_specification: [
          { 
            id: '1',
            name: '抗菌防霧沖切成型AYVG',
            feature: '特色: 透明性佳、硬挺、抗菌、防霧',
            outward: '外觀: 透明',
            thickness: '參考厚度<sub>(mm)</sub> ：0.2~0.8 ',
            proportion: '比重<sub>(g/cm3)</sub> ：1.34±0.01',
            transmittance: '透光度<sub>(透明製品,%)</sub>：<br/> <span class="pl-5">90</span>',
            gloss: '防霧性<sub>(1min不起霧)</sub>：<br/> <span class="pl-5">50°C/95°C</span>',
            mist: '抗菌效果<sub>(%)</sub>：<br/> <span class="pl-5">5菌種 R>2.0</span>'},
          { 
            id: '2',
            name: '食品真空成型用(B級)AFVB',
            feature: '特色: 透明性佳、成型性良好',
            outward: '外觀: 透明、有色',
            thickness: '參考厚度<sub>(mm)</sub>：0.40 ',
            proportion: '比重<sub>(g/cm3)</sub>：1.34±0.01',
            transmittance: '透光度<sub>(透明製品,%)</sub>:<br/><span class="pl-5">88～92</span>',
            gloss: '光澤度<sub>(透明製品)</sub>：<br/><span class="pl-5">158～168</span>',
            mist: '霞霧度<sub>(%)</sub>：<br/><span class="pl-5">≦3.0</span>'},
          { 
            id: '3',
            name: '食品一般真空成型AFVG',
            feature: '特色: 透明性佳、成型性良好',
            outward: '外觀: 透明、有色',
            thickness: '參考厚度<sub>(mm)</sub> ：0.40 ',
            proportion: '比重<sub>(g/cm3)</sub> ：1.34±0.01',
            transmittance: '透光度<sub>(透明製品,%)</sub>：<br/><span class="pl-5">88～92</span>',
            gloss: '光澤度<sub>(透明製品)</sub> ：<br/><span class="pl-5">158～168</span>',
            mist: '霞霧度<sub>(%)</sub>：<br/><span class="pl-5">≦3.0</span>' },
          { 
            id: '4',
            name: '食品深模真空成型AFVD',
            feature: '特色: 透明性佳、成型時耐熱性良好',
            outward: '外觀: 透明、有色',
            thickness: '參考厚度<sub>(mm)</sub> ：0.40',
            proportion: '比重<sub>(g/cm3)</sub> ：1.34±0.01',
            transmittance: '透光度<sub>(透明製品,%)</sub>：<br/> <span class="pl-5">88～92</span>',
            gloss: '光澤度<sub>(透明製品)</sub>：<br/> <span class="pl-5">158～168</span>',
            mist: '霞霧度<sub>(%)</sub>：<br/> <span class="pl-5">≦3.0</span>'},
          { 
            id: '5',
            name: '微波烘焙用AFVM ',
            feature: '特色: 耐熱性佳',
            outward: '外觀: 透明、有色',
            thickness: '參考厚度<sub>(mm)</sub> ：0.50 ',
            proportion: '比重<sub>(g/cm3)</sub> ：1.34±0.01',
            transmittance: '透光度<sub>(透明製品,%)</sub>：<br/> <span class="pl-5">88～92</span>',
            gloss: '光澤度<sub>(透明製品)</sub>：<br/> <span class="pl-5">158～168</span>',
            mist: '霞霧度<sub>(%)</sub>：<br/> <span class="pl-5">≦3.0</span>'}
        ],
        swiperOption_pvc: {
          spaceBetween: 30,
          slidesPerView: 3,
          breakpoints: {
            1170: {
              spaceBetween: 30,
              slidesPerView: 'auto'
            },
            991: {
              spaceBetween: 30,
              slidesPerView: 'auto',
              pagination: {
                el: '.swiper-pagination',
                clickable: true
              }
            },
            410: {
              spaceBetween: 10,
              slidesPerView: 'auto',
              pagination: {
                el: '.swiper-pagination',
                clickable: true
              }
            }
          }
        },
        swiperOption_apet: {
          slidesPerView: 4,
          spaceBetween: 30,
          breakpoints: {
            1550: {
              spaceBetween: 30,
              slidesPerView: 'auto',
            },
            991: {
              spaceBetween: 30,
              slidesPerView: 'auto',
              pagination: {
                el: '.swiper-pagination',
                clickable: true
              }
            },
            410: {
              spaceBetween: 10,
              slidesPerView: 'auto',
              pagination: {
                el: '.swiper-pagination',
                clickable: true
              }
            }
          }
        },
        swiperOption: {
          slidesPerView: 3,
          spaceBetween: 51,
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          breakpoints: {
            1024: {
              slidesPerView: 2,
              spaceBetween: 50
            },
            767: {
              slidesPerView: 1,
              spaceBetween: 50
            }
          }
        },
        swiperdata: [
          {
            id:'2',
            name:'抗靜電包裝',
            text:'採用吸塑設備，利用高溫及模具，將平面的塑膠片，成型出立體包裝曲面殼，以讓消費者可直接透視產品並保護之。',
            url:'./img/application_Desktop/other_pic_2.jpg',
            href_link: 'anti_static'
          },
          {
            id:'3',
            name:'建材裝潢',
            text:'在連續基材上，經過印刷、塗佈、貼合或壓製等工藝而製成的產品。 複合塑膠建材裝璜產品是由多層結構熱壓而成..',
            url:'./img/application_Desktop/other_pic_3.jpg',
            href_link: 'decoration'
          },
          {
            id:'4',
            name:'卡片貼合',
            text:'本製品可經印刷、貼合、衝卡、打碼、分卡質檢等工序製成各種卡片。',
            url:'./img/application_Desktop/other_pic_4.jpg',
            href_link: 'card_Lamination'
          },
          {
            id:'5',
            name:'事務文具',
            text:'本製品可經印刷、貼合、沖裁或熔著等工序製成各種事務文具用產品。',
            url:'./img/application_Desktop/other_pic_5.jpg',
            href_link: 'office_stationery'
          },
          {
            id:'6',
            name:'水處理',
            text:'本製品之加工方式有軋壓及成型兩種。客戶若使用成型方式加工，則須特別管制成型性。',
            url:'./img/application_Desktop/other_pic_6.jpg',
            href_link: 'water_treatment'
          },
          {
            id:'7',
            name:'Green APET',
            text:'PCR粒是回收寶特瓶再生原料，達到重複使用、再生循環，符合低碳排放與減廢之環保訴求',
            url:'./img/application_Desktop/other_pic_7.jpg',
            href_link: 'green_apet'
          },
          {
            id:'8',
            name:'C-PET膠布',
            text:'C-PET膠布需經由壓空成型機模具加熱成型使其結晶，成型品可耐高溫。',
            url:'./img/application_Desktop/other_pic_8.jpg',
            href_link: 'Cpet-sheet'
          }
        ]
      }
    },
  methods: {
    change:function(item) {
      if(item === 'PVC'){
        this.p_show[0].show = true
        this.p_show[1].show = false
      }
      else{
        this.p_show[1].show = true
        this.p_show[0].show = false
      }
      // for(let i in this.p_show){
      //   this.p_show[i].show = !this.p_show[i].show
      // }
      // this.p_show[0].show = false
      // this.p_show[1].show = true
      // this.p_show = !this.p_show
      // for(let i=0; i<this.p_show.length; i++){
      //   this.p_show[i] = !this.p_show[i]
      //   console.log(i)
      // }
      // console.log(this.p_show[1] + "," + this.p_show[0])
      }
      // if(event){
      //   this.p_show[0] = true
      //   this.p_show[1] = true
      //   console.log(this.p_show[1])}
    // }
  },
}
</script>
<style lang="sass">
@import '@/css/product.sass'

</style>
